import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { getToken } from "../../utils/getToken";

export const useMarkToInReview = () => {
  const token = getToken();
  return useMutation({
    mutationFn: (id: string) =>
      axiosInstance
        .patch(`/credits/${id}/review`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {},
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
